import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.ppt');
import { HostListener } from '@angular/core';

@Component({
    selector: 'wiz-page-ppt',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.ppt/view.scss */
:host {
  display: block;
  min-height: 100vh;
  background: #eef2f7;
  color: #1f2937;
}

.ppt-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #f8fafc 0%, #e9eef6 100%);
  font-family: "Pretendard Variable", "Pretendard", "SUIT", "Noto Sans KR", "Malgun Gothic", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
  text-rendering: geometricPrecision;
  font-feature-settings: "kern";
}

.ppt-toolbar {
  position: sticky;
  top: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  height: 72px;
  padding: 0 28px;
  border-bottom: 1px solid rgba(148, 163, 184, 0.32);
  background: rgba(248, 250, 252, 0.92);
  backdrop-filter: blur(18px);
}

.ppt-brand {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 260px;
}

.ppt-brand img {
  width: 48px;
  height: 28px;
  object-fit: contain;
}

.ppt-brand p,
.ppt-brand span {
  margin: 0;
}

.ppt-brand p {
  font-size: 14px;
  font-weight: 800;
  color: #10233e;
}

.ppt-brand span {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0;
  color: #667085;
}

.ppt-controls {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #d7dee9;
  border-radius: 999px;
  background: #fff;
  padding: 6px 10px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.08);
}

.ppt-controls button,
.ppt-export {
  border: 0;
  cursor: pointer;
  font: inherit;
}

.ppt-controls button {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: #eef4ff;
  color: #1f5eaa;
  font-size: 22px;
  line-height: 1;
}

.ppt-controls button:disabled {
  cursor: default;
  opacity: 0.35;
}

.ppt-controls strong {
  min-width: 58px;
  text-align: center;
  font-size: 12px;
  color: #344054;
}

.ppt-export {
  border-radius: 999px;
  background: #0b7c80;
  color: #fff;
  padding: 11px 18px;
  font-size: 13px;
  font-weight: 800;
  box-shadow: 0 14px 28px rgba(11, 124, 128, 0.24);
}

.ppt-shell {
  --slide-width: min(1280px, calc(100vw - 68px));
  display: flex;
  align-items: center;
  gap: 32px;
  width: var(--slide-width);
  margin: 0 auto;
  overflow-x: hidden;
  overflow-y: hidden;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  scrollbar-width: none;
  padding: 0;
  height: calc(100vh - 72px);
}

.ppt-shell::-webkit-scrollbar {
  display: none;
  width: 0;
  height: 0;
}

.ppt-slide {
  position: relative;
  flex: 0 0 var(--slide-width);
  aspect-ratio: 16/9;
  min-height: 0;
  max-height: none;
  scroll-snap-align: center;
  overflow: hidden;
  border-radius: 18px;
  border: 1px solid rgba(148, 163, 184, 0.28);
  background: #f8fafc;
  box-shadow: 0 24px 80px rgba(15, 23, 42, 0.16);
  padding: 44px 56px;
}

@supports (width: calc(100px / 2)) {
  .ppt-shell {
    --slide-width: min(1920px, calc(100vw - 96px), calc((100vh - 104px) / 0.5625));
  }
}
.cover {
  padding: 0;
  background: #07162d;
  color: #fff;
}

.cover-bg,
.cover-shade {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
}

.cover-bg {
  object-fit: cover;
}

.cover-shade {
  background: linear-gradient(90deg, rgba(6, 19, 40, 0.92) 0%, rgba(6, 19, 40, 0.7) 52%, rgba(6, 19, 40, 0.4) 100%);
}

.cover-content {
  position: relative;
  z-index: 2;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 66%;
  height: 100%;
  padding: 64px 72px;
}

.cover-logo {
  width: 90px;
  height: auto;
  margin-bottom: 32px;
}

.eyebrow,
.subtitle,
.cover-meta {
  margin: 0;
}

.eyebrow {
  color: rgba(255, 255, 255, 0.72);
  font-size: 15px;
  font-weight: 800;
}

.cover h1 {
  margin: 18px 0 0;
  font-size: 54px;
  line-height: 1.06;
  letter-spacing: 0;
}

.subtitle {
  margin-top: 24px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 19px;
  font-weight: 600;
}

.cover-meta {
  display: flex;
  gap: 12px;
  margin-top: 66px;
}

.cover-meta span {
  border: 1px solid rgba(255, 255, 255, 0.22);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.1);
  padding: 9px 14px;
  color: rgba(255, 255, 255, 0.84);
  font-size: 12px;
  font-weight: 700;
}

.slide-head {
  display: grid;
  grid-template-columns: 56px 1fr;
  gap: 0 18px;
  align-items: start;
  margin-bottom: 30px;
}

.slide-head span {
  grid-row: span 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border-radius: 14px;
  background: #e5f6f5;
  color: #08777b;
  font-size: 14px;
  font-weight: 900;
}

.slide-head h2,
.slide-head p {
  margin: 0;
}

.slide-head h2 {
  color: #10233e;
  font-size: 31px;
  line-height: 1.16;
  letter-spacing: 0;
}

.slide-head p {
  margin-top: 8px;
  color: #667085;
  font-size: 14px;
  font-weight: 650;
}

.metric-grid {
  display: grid;
  gap: 16px;
  margin-bottom: 28px;
}

.metric-grid.four {
  grid-template-columns: 1.35fr repeat(3, 1fr);
}

.metric,
.info-card,
.compare-panel,
.task-card,
.decision,
.rag-step,
.store,
.node {
  border: 1px solid #dbe3ee;
  background: #fff;
  box-shadow: 0 14px 38px rgba(15, 23, 42, 0.07);
}

.metric {
  border-radius: 15px;
  padding: 18px 18px 16px;
}

.metric span,
.metric strong {
  display: block;
}

.metric span {
  color: #667085;
  font-size: 12px;
  font-weight: 800;
}

.metric strong {
  margin-top: 10px;
  color: #0b7c80;
  font-size: 24px;
  line-height: 1.15;
}

.three-columns,
.two-panels {
  display: grid;
  gap: 18px;
}

.three-columns {
  grid-template-columns: repeat(3, 1fr);
}

.two-panels {
  grid-template-columns: repeat(2, 1fr);
  margin-top: 22px;
}

.info-card {
  border-radius: 16px;
  padding: 22px 23px;
}

.info-card h3,
.info-card p,
.info-card ul {
  margin: 0;
}

.info-card h3 {
  color: #10233e;
  font-size: 17px;
  line-height: 1.25;
}

.info-card p {
  margin-top: 12px;
  color: #475467;
  font-size: 13px;
  line-height: 1.7;
}

.info-card ul {
  padding-left: 18px;
  margin-top: 16px;
  color: #344054;
  font-size: 13px;
  line-height: 1.7;
}

.before-after {
  display: grid;
  grid-template-columns: 1fr 72px 1fr;
  align-items: stretch;
  gap: 18px;
  margin-top: 16px;
}

.compare-panel {
  border-radius: 20px;
  padding: 28px 30px;
}

.compare-panel h3,
.compare-panel ul {
  margin: 0;
}

.compare-panel h3 {
  font-size: 22px;
  color: #10233e;
}

.compare-panel ul {
  padding-left: 20px;
  margin-top: 24px;
  font-size: 16px;
  line-height: 2;
  color: #344054;
}

.before {
  background: #fffaf0;
  border-color: #ead9b8;
}

.after {
  background: #f1fbfa;
  border-color: #bfe7e4;
}

.compare-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1f5eaa;
  font-size: 42px;
  font-weight: 900;
}

.change-board {
  display: grid;
  grid-template-columns: 0.92fr 1.28fr;
  gap: 28px;
  margin-top: 16px;
}

.change-current,
.change-rfp {
  border-top: 3px solid #10233e;
  border-bottom: 3px solid #10233e;
  min-height: 312px;
  padding: 24px 0;
}

.change-current span,
.change-rfp > span {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: #e5f6f5;
  color: #08777b;
  font-size: 12px;
  font-weight: 950;
}

.change-current h3,
.change-current ul,
.change-lane b,
.change-lane p {
  margin: 0;
}

.change-current h3 {
  margin-top: 20px;
  color: #10233e;
  font-size: 24px;
  line-height: 1.25;
  font-weight: 950;
}

.change-current ul {
  margin-top: 22px;
  padding-left: 20px;
  color: #344054;
  font-size: 14.5px;
  line-height: 1.82;
  font-weight: 750;
}

.change-rfp {
  display: grid;
  grid-template-rows: 30px repeat(3, 1fr);
  gap: 12px;
}

.change-lane {
  display: grid;
  grid-template-columns: 150px 1fr;
  align-items: center;
  min-height: 70px;
  padding: 0 16px;
  border-left: 5px solid #0b7c80;
  background: #fff;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.06);
}

.change-lane:nth-child(3) {
  border-left-color: #1f5eaa;
}

.change-lane:nth-child(4) {
  border-left-color: #da8b1f;
}

.change-lane b {
  color: #10233e;
  font-size: 16px;
  line-height: 1.28;
  font-weight: 950;
}

.change-lane p {
  color: #475467;
  font-size: 14px;
  line-height: 1.48;
  font-weight: 750;
}

.change-axis {
  display: grid;
  grid-template-columns: 1fr 44px 1fr 44px 1fr 44px 1fr 44px 1fr;
  align-items: center;
  margin-top: 22px;
}

.change-axis span {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
  border-radius: 999px;
  background: #10233e;
  color: #fff;
  font-size: 13px;
  font-weight: 900;
}

.change-axis i {
  display: block;
  height: 2px;
  background: #0b7c80;
}

.fact-note,
.flow-note,
.arch-principle,
.dark-rule {
  border-radius: 14px;
  padding: 15px 18px;
  font-size: 14px;
  font-weight: 800;
  text-align: center;
}

.fact-note,
.flow-note,
.arch-principle {
  margin-top: 24px;
  background: #eaf3ff;
  color: #1f5eaa;
}

.dark-rule {
  margin-top: 24px;
  background: #10233e;
  color: #fff;
}

.arch-diagram {
  border-radius: 20px;
  background: #fff;
  border: 1px solid #dbe3ee;
  padding: 28px;
}

.arch-row {
  display: grid;
  gap: 14px;
}

.arch-row.top {
  grid-template-columns: 1fr 1.1fr 1.25fr 1.45fr 1.15fr 1fr;
}

.node {
  border-radius: 14px;
  padding: 14px 10px;
  text-align: center;
  font-size: 13px;
  font-weight: 900;
  color: #10233e;
}

.node.user,
.node.ops {
  background: #eef4ff;
}

.node.ui,
.node.api {
  background: #e5f6f5;
}

.node.pipeline {
  background: #edf8ef;
}

.node.harness {
  background: #fff3dc;
}

.arch-flow {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  margin: 14px 52px 20px;
}

.arch-flow span {
  height: 2px;
  background: #c7d1df;
}

.arch-row.storage {
  grid-template-columns: repeat(4, 1fr);
}

.store {
  border-radius: 16px;
  padding: 20px 18px;
  min-height: 128px;
}

.store h3,
.store p {
  margin: 0;
  text-align: center;
}

.store h3 {
  color: #10233e;
  font-size: 20px;
}

.store p {
  margin-top: 10px;
  color: #475467;
  font-size: 12px;
  font-weight: 750;
}

.mysql,
.mysql-card {
  background: #eef4ff;
}

.files,
.files-card {
  background: #edf8ef;
}

.milvus,
.milvus-card {
  background: #e5f6f5;
}

.ai {
  background: #fff3dc;
}

.flow-lanes {
  display: grid;
  gap: 24px;
  margin-top: 22px;
}

.lane {
  display: grid;
  grid-template-columns: 118px 1fr;
  align-items: center;
  gap: 18px;
}

.lane h3 {
  margin: 0;
  border-radius: 999px;
  background: #10233e;
  color: #fff;
  padding: 12px 14px;
  text-align: center;
  font-size: 14px;
}

.lane-steps,
.mini-flow {
  display: grid;
  gap: 14px;
}

.lane-steps {
  grid-template-columns: repeat(5, 1fr);
}

.lane-steps span,
.mini-flow span {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 58px;
  border: 1px solid #d7dee9;
  border-radius: 14px;
  background: #fff;
  color: #10233e;
  text-align: center;
  font-size: 12px;
  font-weight: 900;
  line-height: 1.35;
  padding: 0 10px;
}

.lane-steps span:not(:last-child)::after,
.mini-flow span:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -12px;
  top: 50%;
  width: 10px;
  height: 2px;
  background: #b9c4d2;
}

.pipeline-map {
  position: relative;
  margin-top: 22px;
  padding: 18px 20px 20px;
  border-top: 3px solid #10233e;
  border-bottom: 3px solid #10233e;
  background: linear-gradient(90deg, rgba(11, 124, 128, 0.08), rgba(31, 94, 170, 0.06) 48%, rgba(218, 139, 31, 0.07) 76%, rgba(75, 145, 85, 0.08)), rgba(255, 255, 255, 0.58);
}

.pipeline-nodes {
  position: relative;
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
}

.pipeline-nodes::before {
  content: "";
  position: absolute;
  left: 6%;
  right: 6%;
  top: 83px;
  height: 5px;
  border-radius: 999px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa 38%, #da8b1f 68%, #4b9155);
}

.pipeline-node {
  position: relative;
  z-index: 1;
  min-height: 170px;
  padding-top: 64px;
}

.pipeline-node small {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-flex;
  align-items: center;
  min-height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  color: #fff;
  background: #10233e;
  font-size: 11px;
  font-weight: 950;
}

.pipeline-node b {
  position: absolute;
  left: 0;
  top: 48px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 46px;
  height: 46px;
  border: 5px solid #f8fafc;
  border-radius: 50%;
  background: #10233e;
  color: #fff;
  font-size: 15px;
  font-weight: 950;
  box-shadow: 0 12px 24px rgba(15, 23, 42, 0.15);
}

.pipeline-node.data small,
.pipeline-node.data b {
  background: #0b7c80;
}

.pipeline-node.agent small,
.pipeline-node.agent b {
  background: #1f5eaa;
}

.pipeline-node.human small,
.pipeline-node.human b {
  background: #da8b1f;
}

.pipeline-node.output small,
.pipeline-node.output b {
  background: #4b9155;
}

.pipeline-node.regen b {
  box-shadow: 0 0 0 7px rgba(218, 139, 31, 0.16), 0 12px 24px rgba(15, 23, 42, 0.15);
}

.pipeline-node h3,
.pipeline-node p,
.pipeline-roles h3,
.pipeline-roles p,
.harness-zone p {
  margin: 0;
}

.pipeline-node h3 {
  margin-top: 40px;
  color: #10233e;
  font-size: 17px;
  line-height: 1.2;
  font-weight: 950;
}

.pipeline-node p {
  margin-top: 9px;
  color: #475467;
  font-size: 12.2px;
  line-height: 1.42;
  font-weight: 740;
}

.feedback-loop {
  display: flex;
  justify-content: flex-end;
  margin-top: -4px;
  padding-right: 15.5%;
}

.feedback-loop span {
  position: relative;
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 14px;
  border: 1px solid rgba(218, 139, 31, 0.32);
  border-radius: 999px;
  background: #fff3dc;
  color: #9a5b12;
  font-size: 12px;
  font-weight: 900;
}

.feedback-loop span::before {
  content: "";
  position: absolute;
  left: -84px;
  width: 74px;
  height: 2px;
  background: #da8b1f;
}

.harness-zone {
  display: grid;
  grid-template-columns: 120px 1.35fr 1.65fr;
  align-items: center;
  gap: 18px;
  margin-top: 14px;
  min-height: 78px;
  padding: 14px 18px;
  background: #10233e;
  color: #fff;
}

.harness-zone strong {
  font-size: 16px;
  line-height: 1.25;
  font-weight: 950;
}

.harness-checks {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}

.harness-checks span {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 30px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.14);
  color: rgba(255, 255, 255, 0.92);
  font-size: 11px;
  font-weight: 900;
}

.harness-zone p {
  color: rgba(255, 255, 255, 0.78);
  font-size: 12.5px;
  line-height: 1.42;
  font-weight: 740;
}

.pipeline-roles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 0;
  margin-top: 18px;
  border-top: 2px solid rgba(16, 35, 62, 0.2);
  border-bottom: 2px solid rgba(16, 35, 62, 0.2);
}

.pipeline-roles div {
  min-height: 70px;
  padding: 14px 18px;
  border-right: 1px solid rgba(16, 35, 62, 0.14);
}

.pipeline-roles div:last-child {
  border-right: 0;
}

.pipeline-roles h3 {
  color: #0b7c80;
  font-size: 15px;
  font-weight: 950;
}

.pipeline-roles p {
  margin-top: 8px;
  color: #344054;
  font-size: 12.6px;
  line-height: 1.42;
  font-weight: 750;
}

.flowchart-board {
  position: relative;
  z-index: 1;
  margin-top: 8px;
  padding: 16px 18px 18px;
  border: 1px solid rgba(16, 35, 62, 0.14);
  border-radius: 14px;
  background: radial-gradient(circle at 12% 4%, rgba(11, 124, 128, 0.14), transparent 30%), radial-gradient(circle at 84% 12%, rgba(218, 139, 31, 0.14), transparent 30%), linear-gradient(135deg, rgba(255, 255, 255, 0.94), rgba(240, 246, 252, 0.78));
  box-shadow: 0 18px 42px rgba(15, 23, 42, 0.1);
}

.pipeline-board {
  padding: 18px 22px 20px;
}

.pipeline-svg {
  display: block;
  width: 100%;
  height: auto;
  font-family: "Pretendard Variable", "Pretendard", "SUIT", "Noto Sans KR", "Malgun Gothic", -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif;
}

.pipeline-bg {
  fill: rgba(255, 255, 255, 0.72);
  stroke: rgba(16, 35, 62, 0.12);
  stroke-width: 1.5;
}

.scope-out {
  fill: #e6f7f5;
  stroke: #0b7c80;
  stroke-width: 1.4;
}

.scope-in {
  fill: #edf3ff;
  stroke: #1f5eaa;
  stroke-width: 1.4;
}

.scope-out-text,
.scope-in-text {
  font-size: 12px;
  font-weight: 900;
  letter-spacing: 0;
}

.scope-out-text {
  fill: #08777b;
}

.scope-in-text {
  fill: #1f5eaa;
}

.node.input {
  fill: #e6f7f5;
  stroke: #0b7c80;
  stroke-width: 1.8;
}

.db-node rect {
  fill: #f8fbff;
  stroke: #9fb4ca;
  stroke-width: 1.4;
}

.db-node ellipse,
.db-node path {
  fill: #eaf2f8;
  stroke: #9fb4ca;
  stroke-width: 1.3;
}

.node.process {
  stroke: #9eb3ce;
  stroke-width: 1.4;
}

.decision.agent {
  fill: #4338a8;
  stroke: #2b2f7f;
  stroke-width: 1.6;
}

.decision.review {
  fill: #d5801d;
  stroke: #a95712;
  stroke-width: 1.6;
}

.output-node rect {
  stroke: #438a54;
  stroke-width: 1.5;
}

.arrow {
  fill: none;
  stroke: #7f95ad;
  stroke-width: 3;
  stroke-linecap: round;
}

.feedback-band {
  fill: #fff7e8;
  stroke: #da8b1f;
  stroke-width: 1.8;
  stroke-dasharray: 7 6;
}

.feedback-arrow {
  fill: none;
  stroke: #da8b1f;
  stroke-width: 2.2;
  stroke-dasharray: 6 6;
  stroke-linecap: round;
}

.harness-band {
  fill: #10233e;
}

.node-title,
.decision-title,
.feedback-text,
.harness-main,
.harness-sub {
  letter-spacing: 0;
}

.node-title {
  fill: #10233e;
  font-size: 14px;
  font-weight: 950;
}

.node-sub {
  fill: #475467;
  font-size: 10.6px;
  font-weight: 760;
}

.decision-title {
  fill: #fff;
  font-size: 13px;
  font-weight: 950;
}

.decision-sub {
  fill: rgba(255, 255, 255, 0.78);
  font-size: 9.8px;
  font-weight: 780;
}

.feedback-text {
  fill: #9a5b12;
  font-size: 12.2px;
  font-weight: 900;
}

.harness-main {
  fill: #fff;
  font-size: 13.2px;
  font-weight: 900;
}

.harness-sub {
  fill: rgba(255, 255, 255, 0.72);
  font-size: 10.8px;
  font-weight: 720;
}

.flowchart-legend {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.flowchart-legend span {
  display: inline-flex;
  align-items: center;
  min-height: 24px;
  border-radius: 999px;
  padding: 0 10px;
  color: #fff;
  font-size: 10.5px;
  font-weight: 900;
}

.flowchart-legend .source {
  background: #0b7c80;
}

.flowchart-legend .engine {
  background: #1f5eaa;
}

.flowchart-legend .gate {
  background: #5946b2;
}

.flowchart-legend .human {
  background: #da8b1f;
}

.flowchart-legend .output {
  background: #438a54;
}

.flowchart-canvas {
  display: grid;
  gap: 9px;
}

.flowchart-row {
  display: grid;
  grid-template-columns: 92px 1.04fr 26px 1.16fr 26px 1.08fr 26px 1.28fr;
  align-items: stretch;
  min-height: 82px;
  gap: 0 8px;
}

.flow-lane {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 12px;
  padding: 12px 10px;
  color: #fff;
}

.flow-lane b,
.flow-lane small,
.flow-shape strong,
.flow-shape p,
.flow-shape em,
.flow-shape span {
  margin: 0;
}

.flow-lane b {
  font-size: 13px;
  line-height: 1.15;
  font-weight: 950;
}

.flow-lane small {
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.78);
  font-size: 9.5px;
  line-height: 1.28;
  font-weight: 780;
}

.flow-lane.source {
  background: linear-gradient(135deg, #0b7c80, #0a6570);
}

.flow-lane.engine {
  background: linear-gradient(135deg, #1f5eaa, #5946b2);
}

.flow-lane.human {
  background: linear-gradient(135deg, #da8b1f, #ad5f17);
}

.flow-shape {
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-width: 0;
  min-height: 82px;
  padding: 10px 12px;
  border: 1px solid rgba(16, 35, 62, 0.11);
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 12px 26px rgba(15, 23, 42, 0.09);
}

.flow-shape strong {
  display: block;
  color: #10233e;
  font-size: 13px;
  line-height: 1.18;
  font-weight: 950;
}

.flow-shape p {
  margin-top: 7px;
  color: #48576b;
  font-size: 10.4px;
  line-height: 1.32;
  font-weight: 720;
}

.flow-shape em {
  align-self: flex-start;
  margin-bottom: 6px;
  border-radius: 999px;
  background: rgba(11, 124, 128, 0.11);
  padding: 3px 7px;
  color: #08777b;
  font-size: 9px;
  font-style: normal;
  font-weight: 950;
}

.flow-shape.terminator {
  border-radius: 999px;
  border-color: rgba(11, 124, 128, 0.3);
  background: linear-gradient(135deg, #f8ffff, #e5f6f5);
}

.flow-shape.cylinder {
  justify-content: flex-start;
  border-radius: 12px 12px 18px 18px;
  padding-top: 21px;
  border-color: rgba(16, 35, 62, 0.18);
  background: linear-gradient(180deg, #fff 0%, #eef6fb 100%);
  overflow: hidden;
}

.flow-shape.cylinder::before,
.flow-shape.cylinder::after {
  content: "";
  position: absolute;
  left: 9px;
  right: 9px;
  height: 17px;
  border: 2px solid rgba(16, 35, 62, 0.16);
  border-radius: 50%;
}

.flow-shape.cylinder::before {
  top: 8px;
  background: rgba(31, 94, 170, 0.07);
}

.flow-shape.cylinder::after {
  bottom: 7px;
  border-top-color: transparent;
  opacity: 0.55;
}

.flow-shape.mysql {
  border-left: 5px solid #0b7c80;
}

.flow-shape.milvus {
  border-left: 5px solid #1f5eaa;
}

.flow-shape.document {
  border-radius: 6px 16px 6px 6px;
  border-left: 5px solid #5b7bd6;
  background: linear-gradient(145deg, #fff, #eef4ff);
}

.flow-shape.document::after {
  content: "";
  position: absolute;
  right: -1px;
  top: -1px;
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #dbe7ff 0 50%, #fff 51%);
  border-left: 1px solid rgba(16, 35, 62, 0.12);
  border-bottom: 1px solid rgba(16, 35, 62, 0.12);
  border-radius: 0 14px 0 4px;
}

.flow-shape.input {
  border-radius: 10px;
  transform: skewX(-7deg);
  border-left: 5px solid #5b7bd6;
  background: #f4f7ff;
}

.flow-shape.input > * {
  transform: skewX(7deg);
}

.flow-shape.process {
  border-radius: 12px;
}

.flow-shape.process.codex {
  border-left: 5px solid #1f5eaa;
  background: linear-gradient(135deg, #fff, #edf5ff);
}

.flow-shape.process.filter {
  border-left: 5px solid #5946b2;
  background: linear-gradient(135deg, #fff, #f1efff);
}

.flow-shape.queue {
  border-radius: 14px 14px 8px 8px;
  border-left: 5px solid #da8b1f;
  background: linear-gradient(90deg, rgba(218, 139, 31, 0.1) 0 14px, transparent 14px), #fffaf2;
}

.flow-shape.process.review {
  border-left: 5px solid #b46813;
  background: linear-gradient(135deg, #fff, #fff4df);
}

.flow-shape.decision {
  align-items: center;
  justify-content: center;
  min-height: 82px;
  border: 0;
  background: transparent;
  box-shadow: none;
  padding: 0;
}

.flow-shape.decision > div {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 74px;
  height: 74px;
  padding: 0 12px;
  background: linear-gradient(135deg, #283d80, #5946b2);
  color: #fff;
  text-align: center;
  transform: rotate(45deg);
  box-shadow: 0 14px 28px rgba(89, 70, 178, 0.22);
}

.flow-shape.decision > div > * {
  transform: rotate(-45deg);
}

.flow-shape.decision strong {
  color: #fff;
  font-size: 10.4px;
  line-height: 1.12;
}

.flow-shape.decision span {
  margin-top: 4px;
  color: rgba(255, 255, 255, 0.76);
  font-size: 8px;
  line-height: 1.16;
  font-weight: 820;
}

.flow-shape.decision.approve > div {
  background: linear-gradient(135deg, #ad5f17, #da8b1f);
  box-shadow: 0 14px 28px rgba(218, 139, 31, 0.24);
}

.flow-shape.output {
  border-radius: 14px;
  border-left: 5px solid #438a54;
  background: linear-gradient(145deg, rgba(67, 138, 84, 0.08), transparent 42%), #f7fff8;
}

.flow-link {
  position: relative;
  align-self: center;
  height: 3px;
  background: #91a3ba;
}

.flow-link::after {
  content: "";
  position: absolute;
  right: -1px;
  top: 50%;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  border-left: 8px solid #91a3ba;
  transform: translateY(-50%);
}

.flowchart-feedback-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10px;
  margin-left: 100px;
}

.feedback-pill {
  display: grid;
  grid-template-columns: 132px 1fr;
  align-items: center;
  min-height: 34px;
  border: 2px dashed rgba(218, 139, 31, 0.68);
  border-radius: 12px;
  background: rgba(255, 248, 235, 0.96);
  color: #9a5b12;
  padding: 0 12px;
  box-shadow: 0 10px 24px rgba(154, 91, 18, 0.1);
}

.feedback-pill b,
.feedback-pill span {
  margin: 0;
}

.feedback-pill b {
  color: #9a5b12;
  font-size: 10.3px;
  line-height: 1.1;
  font-weight: 950;
}

.feedback-pill span {
  color: #9a5b12;
  font-size: 10px;
  line-height: 1.1;
  font-weight: 800;
}

.flowchart-harness {
  position: relative;
  z-index: 1;
  display: grid;
  grid-template-columns: 168px 1fr 310px;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
  min-height: 78px;
  padding: 12px 16px;
  border-radius: 14px;
  background: linear-gradient(90deg, rgba(31, 94, 170, 0.34), rgba(89, 70, 178, 0.3)), #10233e;
  color: #fff;
  box-shadow: 0 18px 34px rgba(16, 35, 62, 0.16);
}

.harness-title strong,
.harness-title span,
.flowchart-harness p,
.harness-track b,
.harness-track span {
  margin: 0;
}

.harness-title {
  display: flex;
  flex-direction: column;
}

.harness-title strong {
  font-size: 15px;
  line-height: 1.16;
  font-weight: 950;
}

.harness-title span {
  margin-top: 6px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 10.5px;
  font-weight: 780;
}

.harness-track {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 8px;
}

.harness-track div {
  min-height: 44px;
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.1);
  padding: 7px 8px;
}

.harness-track b,
.harness-track span {
  display: block;
  text-align: center;
}

.harness-track b {
  color: #fff;
  font-size: 11px;
  line-height: 1.1;
  font-weight: 950;
}

.harness-track span {
  margin-top: 4px;
  color: rgba(255, 255, 255, 0.68);
  font-size: 8.7px;
  line-height: 1.16;
  font-weight: 760;
}

.flowchart-harness p {
  color: rgba(255, 255, 255, 0.76);
  font-size: 11px;
  line-height: 1.36;
  font-weight: 720;
}

.rag-flow {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 18px;
  margin-top: 18px;
}

.rag-step {
  position: relative;
  border-radius: 18px;
  padding: 24px 22px;
  min-height: 220px;
}

.rag-step:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -14px;
  top: 50%;
  width: 12px;
  height: 2px;
  background: #b9c4d2;
}

.rag-step strong {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #e5f6f5;
  color: #08777b;
  font-size: 14px;
}

.rag-step h3,
.rag-step p {
  margin: 0;
}

.rag-step h3 {
  margin-top: 20px;
  color: #10233e;
  font-size: 18px;
}

.rag-step p {
  margin-top: 13px;
  color: #475467;
  font-size: 13px;
  line-height: 1.65;
}

.mini-flow {
  grid-template-columns: repeat(6, 1fr);
  margin-top: 28px;
}

.data-compare {
  display: grid;
  gap: 14px;
  margin-top: 18px;
}

.data-compare .row {
  display: grid;
  grid-template-columns: 1.2fr 2fr 2.4fr;
  align-items: center;
  gap: 16px;
}

.data-compare b,
.data-compare span,
.data-compare strong {
  border-radius: 14px;
  min-height: 58px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 0 16px;
  font-size: 13px;
}

.data-compare b {
  background: #eef4ff;
  color: #1f5eaa;
}

.data-compare span {
  border: 1px solid #ead9b8;
  background: #fffaf0;
  color: #344054;
}

.data-compare strong {
  border: 1px solid #bfe7e4;
  background: #f1fbfa;
  color: #10233e;
}

.progress-grid {
  display: grid;
  gap: 14px;
  margin-top: 18px;
}

.progress-row {
  display: grid;
  grid-template-columns: 240px 1fr 56px;
  align-items: center;
  gap: 18px;
}

.progress-row .label strong,
.progress-row .label span {
  display: block;
}

.progress-row .label strong {
  color: #10233e;
  font-size: 14px;
}

.progress-row .label span {
  margin-top: 4px;
  color: #667085;
  font-size: 11px;
  font-weight: 700;
}

.track {
  height: 14px;
  border-radius: 999px;
  background: #e4eaf2;
  overflow: hidden;
}

.fill {
  height: 100%;
  border-radius: inherit;
  background: #0b7c80;
}

.fill.mid {
  background: #da8b1f;
}

.fill.warn {
  background: #b94141;
}

.progress-row b {
  color: #475467;
  font-size: 12px;
}

.status-summary {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 26px;
}

.status-summary span {
  border-radius: 14px;
  background: #10233e;
  color: #fff;
  padding: 14px 12px;
  text-align: center;
  font-size: 12px;
  font-weight: 800;
}

.progress-board {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 24px;
  margin-top: 18px;
}

.progress-column {
  min-height: 310px;
  padding: 24px 22px;
  border-top: 4px solid #10233e;
  border-bottom: 4px solid #10233e;
  background: rgba(255, 255, 255, 0.58);
}

.progress-column.done {
  border-top-color: #0b7c80;
}

.progress-column.active {
  border-top-color: #da8b1f;
}

.progress-column.next {
  border-top-color: #1f5eaa;
}

.progress-column span {
  display: inline-flex;
  align-items: center;
  min-height: 30px;
  padding: 0 12px;
  border-radius: 999px;
  background: #10233e;
  color: #fff;
  font-size: 12px;
  font-weight: 950;
}

.progress-column.done span {
  background: #0b7c80;
}

.progress-column.active span {
  background: #da8b1f;
}

.progress-column.next span {
  background: #1f5eaa;
}

.progress-column h3,
.progress-column ul {
  margin: 0;
}

.progress-column h3 {
  margin-top: 18px;
  color: #10233e;
  font-size: 22px;
  line-height: 1.25;
  font-weight: 950;
}

.progress-column ul {
  margin-top: 20px;
  padding-left: 19px;
  color: #344054;
  font-size: 13.5px;
  line-height: 1.62;
  font-weight: 750;
}

.progress-proof {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  margin-top: 20px;
  border-top: 2px solid rgba(16, 35, 62, 0.2);
  border-bottom: 2px solid rgba(16, 35, 62, 0.2);
}

.progress-proof div {
  min-height: 74px;
  padding: 15px 16px;
  border-right: 1px solid rgba(16, 35, 62, 0.14);
}

.progress-proof div:last-child {
  border-right: 0;
}

.progress-proof b,
.progress-proof p {
  margin: 0;
}

.progress-proof b {
  color: #0b7c80;
  font-size: 13px;
  font-weight: 950;
}

.progress-proof p {
  margin-top: 8px;
  color: #344054;
  font-size: 12.5px;
  line-height: 1.42;
  font-weight: 750;
}

.task-grid,
.decision-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
}

.task-card,
.decision {
  border-radius: 16px;
  padding: 18px 20px;
}

.task-card span,
.decision b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #eef4ff;
  color: #1f5eaa;
  min-width: 44px;
  height: 26px;
  font-size: 11px;
  font-weight: 900;
}

.task-card.p0 span {
  background: #ffecec;
  color: #b94141;
}

.task-card.p1 span {
  background: #fff3dc;
  color: #a76300;
}

.task-card h3,
.task-card p,
.decision h3,
.decision p {
  margin: 0;
}

.task-card h3 {
  margin-top: 14px;
  color: #10233e;
  font-size: 16px;
}

.task-card p,
.decision p {
  margin-top: 8px;
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
}

.timeline {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 14px;
  margin-top: 58px;
}

.timeline-item {
  position: relative;
  border-radius: 18px;
  background: #fff;
  border: 1px solid #dbe3ee;
  min-height: 210px;
  padding: 22px 18px;
}

.timeline-item::before {
  content: "";
  position: absolute;
  left: 18px;
  right: 18px;
  top: -30px;
  height: 2px;
  background: #b9c4d2;
}

.timeline-item span {
  display: inline-flex;
  border-radius: 999px;
  background: #e5f6f5;
  color: #08777b;
  padding: 7px 10px;
  font-size: 11px;
  font-weight: 900;
}

.timeline-item h3,
.timeline-item p {
  margin: 0;
}

.timeline-item h3 {
  margin-top: 18px;
  color: #10233e;
  font-size: 16px;
}

.timeline-item p {
  margin-top: 10px;
  color: #667085;
  font-size: 12px;
  line-height: 1.55;
}

.decision {
  display: grid;
  grid-template-columns: 46px 1fr;
  gap: 14px;
  align-items: start;
}

.decision b {
  width: 34px;
  min-width: 34px;
  height: 34px;
}

.decision h3 {
  color: #10233e;
  font-size: 16px;
}

/* Presentation quality upgrade */
.ppt-toolbar {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(248, 250, 252, 0.9)), #fff;
  box-shadow: 0 14px 38px rgba(15, 23, 42, 0.08);
}

.ppt-brand {
  position: relative;
}

.ppt-brand::after {
  content: "";
  width: 1px;
  height: 28px;
  margin-left: 8px;
  background: #d7dee9;
}

.ppt-export {
  transition: transform 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.ppt-export:hover {
  transform: translateY(-1px);
  background: #096c70;
  box-shadow: 0 18px 36px rgba(11, 124, 128, 0.3);
}

.ppt-slide:not(.cover) {
  background: linear-gradient(90deg, rgba(11, 124, 128, 0.08), rgba(31, 94, 170, 0.05) 34%, rgba(218, 139, 31, 0.05) 100%), linear-gradient(#f8fafc, #f8fafc);
}

.ppt-slide:not(.cover)::before {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(16, 35, 62, 0.05) 1px, transparent 1px), linear-gradient(rgba(16, 35, 62, 0.04) 1px, transparent 1px);
  background-size: 42px 42px;
  mask-image: linear-gradient(180deg, rgba(0, 0, 0, 0.36), transparent 58%);
}

.ppt-slide:not(.cover)::after {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 7px;
  background: linear-gradient(90deg, #0b7c80 0%, #1f5eaa 46%, #da8b1f 100%);
}

.cover h1,
.slide-head h2,
.metric strong,
.compare-panel h3,
.info-card h3,
.store h3,
.rag-step h3,
.db-metric strong,
.db-group h3,
.schema-node h3,
.schema-branch h3,
.task-card h3,
.timeline-item h3,
.decision h3 {
  text-wrap: balance;
}

.slide-head {
  position: relative;
  z-index: 1;
}

.slide-head span {
  background: linear-gradient(135deg, rgba(11, 124, 128, 0.18), rgba(31, 94, 170, 0.12)), #fff;
  box-shadow: inset 0 0 0 1px rgba(11, 124, 128, 0.2), 0 10px 24px rgba(11, 124, 128, 0.12);
}

.metric,
.info-card,
.compare-panel,
.task-card,
.decision,
.rag-step,
.store,
.node,
.timeline-item {
  position: relative;
  overflow: hidden;
  border-color: rgba(190, 200, 214, 0.86);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.09);
}

.metric::before,
.info-card::before,
.compare-panel::before,
.task-card::before,
.decision::before,
.timeline-item::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 4px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa);
}

.metric:nth-child(3)::before,
.before::before,
.task-card.p1::before {
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.task-card.p0::before {
  background: linear-gradient(90deg, #b94141, #db6b6b);
}

.after::before,
.milvus-card::before {
  background: linear-gradient(90deg, #0b7c80, #40b4a7);
}

.files-card::before {
  background: linear-gradient(90deg, #4b9155, #87bd77);
}

.metric strong {
  font-size: 25px;
  font-weight: 900;
}

.cover h1 {
  font-size: 60px;
  font-weight: 900;
}

.subtitle {
  font-size: 21px;
  font-weight: 750;
}

.slide-head h2 {
  font-size: 37px;
  font-weight: 900;
}

.slide-head p {
  font-size: 16px;
  font-weight: 800;
}

.metric span {
  font-size: 13px;
}

.metric strong {
  font-size: 30px;
}

.info-card h3 {
  font-size: 19px;
  font-weight: 900;
}

.info-card p,
.info-card ul {
  font-size: 14px;
  font-weight: 650;
}

.compare-panel h3 {
  font-size: 24px;
  font-weight: 900;
}

.compare-panel ul {
  font-size: 17px;
  font-weight: 650;
}

.info-card ul {
  list-style: none;
  padding-left: 0;
}

.info-card li {
  position: relative;
  padding-left: 15px;
}

.info-card li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0.78em;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #0b7c80;
}

.before li::before {
  background: #da8b1f;
}

.arch-diagram {
  position: relative;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(247, 250, 252, 0.96)), radial-gradient(circle at 16% 8%, rgba(11, 124, 128, 0.1), transparent 30%);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7), 0 18px 54px rgba(15, 23, 42, 0.08);
}

.arch-row.top .node {
  min-height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-width: 1.5px;
  font-size: 12.5px;
}

.node::before {
  content: "";
  position: absolute;
  top: 9px;
  left: 50%;
  width: 24px;
  height: 3px;
  border-radius: 999px;
  transform: translateX(-50%);
  background: currentColor;
  opacity: 0.32;
}

.arch-flow span {
  position: relative;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, #bcc7d6, #8fa3bd);
}

.arch-flow span::after,
.lane-steps span:not(:last-child)::before,
.mini-flow span:not(:last-child)::before,
.rag-step:not(:last-child)::before {
  content: "";
  position: absolute;
  border-style: solid;
}

.arch-flow span::after {
  right: -2px;
  top: -4px;
  border-width: 5px 0 5px 8px;
  border-color: transparent transparent transparent #8fa3bd;
}

.store {
  padding-top: 54px;
}

.store::before {
  position: absolute;
  top: 16px;
  left: 50%;
  transform: translateX(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 42px;
  height: 26px;
  border-radius: 999px;
  color: #fff;
  font-size: 10px;
  font-weight: 900;
}

.store.mysql::before {
  content: "DB";
  background: #1f5eaa;
}

.store.files::before {
  content: "FILE";
  background: #4b9155;
}

.store.milvus::before {
  content: "ANN";
  background: #0b7c80;
}

.store.ai::before {
  content: "AI";
  background: #da8b1f;
}

.lane {
  padding: 10px 12px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px solid rgba(219, 227, 238, 0.86);
}

.lane h3 {
  box-shadow: 0 14px 30px rgba(16, 35, 62, 0.16);
}

.lane-steps,
.mini-flow {
  counter-reset: flow-step;
}

.lane-steps span,
.mini-flow span {
  min-height: 64px;
  background: linear-gradient(180deg, #fff, #f7fafc);
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.06);
}

.lane-steps span::after,
.mini-flow span::after {
  width: 16px !important;
  height: 3px !important;
  right: -15px !important;
  border-radius: 999px;
  background: linear-gradient(90deg, #b9c4d2, #91a3ba) !important;
}

.lane-steps span:not(:last-child)::before,
.mini-flow span:not(:last-child)::before {
  right: -19px;
  top: calc(50% - 5px);
  border-width: 5px 0 5px 8px;
  border-color: transparent transparent transparent #91a3ba;
  z-index: 2;
}

.lane-steps span {
  counter-increment: flow-step;
}

.lane-steps span > *,
.mini-flow span > * {
  position: relative;
  z-index: 1;
}

.rag-step {
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98), rgba(247, 250, 252, 0.98)), #fff;
}

.rag-step strong {
  width: 42px;
  height: 42px;
  font-size: 15px;
  font-weight: 900;
  box-shadow: inset 0 0 0 1px rgba(11, 124, 128, 0.18), 0 10px 24px rgba(11, 124, 128, 0.12);
}

.rag-step:not(:last-child)::after {
  width: 20px;
  height: 3px;
  right: -19px;
  border-radius: 999px;
  background: linear-gradient(90deg, #b9c4d2, #91a3ba);
}

.rag-step:not(:last-child)::before {
  right: -24px;
  top: calc(50% - 5px);
  border-width: 5px 0 5px 8px;
  border-color: transparent transparent transparent #91a3ba;
  z-index: 2;
}

.data-compare .row {
  padding: 8px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.68);
  border: 1px solid rgba(219, 227, 238, 0.8);
}

.progress-row {
  padding: 10px 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.74);
  border: 1px solid rgba(219, 227, 238, 0.86);
}

.track {
  height: 16px;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.1);
}

.fill {
  background: linear-gradient(90deg, #0b7c80, #3ab1a7);
}

.fill.mid {
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.fill.warn {
  background: linear-gradient(90deg, #b94141, #db6b6b);
}

.timeline {
  position: relative;
}

.timeline::before {
  content: "";
  position: absolute;
  top: -30px;
  left: 5%;
  right: 5%;
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa, #da8b1f, #4b9155);
}

.timeline-item::before {
  left: 50%;
  right: auto;
  top: -38px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: #fff;
  border: 3px solid #0b7c80;
  transform: translateX(-50%);
}

.arch-row.top .node {
  font-size: 14px;
  line-height: 1.28;
}

.store h3 {
  font-size: 22px;
}

.store p {
  font-size: 13px;
  line-height: 1.45;
}

.lane h3 {
  font-size: 15px;
  font-weight: 900;
}

.lane-steps span,
.mini-flow span {
  font-size: 13.5px;
}

.rag-step h3 {
  font-size: 20px;
}

.rag-step p {
  font-size: 14px;
  font-weight: 650;
}

.data-compare b,
.data-compare span,
.data-compare strong {
  font-size: 14.5px;
  font-weight: 850;
}

.progress-row .label strong {
  font-size: 16px;
  font-weight: 900;
}

.progress-row .label span {
  font-size: 12.5px;
}

.task-card h3,
.timeline-item h3,
.decision h3 {
  font-size: 18px;
}

.task-card p,
.timeline-item p,
.decision p {
  font-size: 13.5px;
}

.db-dashboard {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 12px;
  margin-top: 10px;
}

.db-metric,
.db-group,
.schema-node,
.schema-branch,
.db-table-row {
  position: relative;
  border: 1px solid rgba(190, 200, 214, 0.9);
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 16px 42px rgba(15, 23, 42, 0.08);
}

.db-metric {
  overflow: hidden;
  min-height: 136px;
  border-radius: 18px;
  padding: 18px 16px 16px;
}

.db-metric::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 5px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa);
}

.db-metric:nth-child(2)::before {
  background: linear-gradient(90deg, #1f5eaa, #5c8ed8);
}

.db-metric:nth-child(3)::before {
  background: linear-gradient(90deg, #4b9155, #87bd77);
}

.db-metric:nth-child(4)::before {
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.db-metric:nth-child(5)::before {
  background: linear-gradient(90deg, #10233e, #465b78);
}

.db-metric:nth-child(6)::before {
  background: linear-gradient(90deg, #667085, #98a2b3);
}

.db-metric span,
.db-metric strong,
.db-metric p {
  display: block;
  margin: 0;
}

.db-metric span {
  color: #667085;
  font-size: 13px;
  font-weight: 900;
}

.db-metric strong {
  margin-top: 13px;
  color: #10233e;
  font-size: 28px;
  line-height: 1;
  font-weight: 950;
}

.db-metric p {
  margin-top: 14px;
  color: #475467;
  font-size: 12.5px;
  line-height: 1.45;
  font-weight: 750;
}

.db-group-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-top: 18px;
}

.db-group {
  min-height: 142px;
  border-radius: 18px;
  padding: 20px;
  overflow: hidden;
}

.db-group::after {
  content: "";
  position: absolute;
  right: -30px;
  bottom: -38px;
  width: 110px;
  height: 110px;
  border-radius: 24px;
  border: 18px solid rgba(11, 124, 128, 0.1);
  transform: rotate(18deg);
}

.db-group h3,
.db-group strong,
.db-group p {
  position: relative;
  z-index: 1;
  margin: 0;
}

.db-group h3 {
  color: #10233e;
  font-size: 18px;
  font-weight: 900;
}

.db-group strong {
  display: block;
  margin-top: 14px;
  color: #0b7c80;
  font-size: 17px;
  line-height: 1.25;
  font-weight: 900;
}

.db-group p {
  margin-top: 10px;
  color: #475467;
  font-size: 13px;
  line-height: 1.55;
  font-weight: 650;
}

.schema-map {
  border: 1px solid rgba(190, 200, 214, 0.9);
  border-radius: 22px;
  padding: 24px;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.96), rgba(247, 250, 252, 0.96)), radial-gradient(circle at 12% 20%, rgba(31, 94, 170, 0.1), transparent 34%);
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.7), 0 18px 54px rgba(15, 23, 42, 0.08);
}

.schema-flow.core {
  display: grid;
  grid-template-columns: 1fr 26px 1fr 26px 1fr 26px 1fr 26px 1fr 26px 1fr;
  align-items: stretch;
  gap: 10px;
}

.schema-node {
  min-height: 138px;
  border-radius: 18px;
  padding: 18px 14px 16px;
  overflow: hidden;
}

.schema-node::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 5px;
  background: linear-gradient(90deg, #1f5eaa, #0b7c80);
}

.schema-node.evidence::before {
  background: linear-gradient(90deg, #0b7c80, #4b9155);
}

.schema-node.vector::before {
  background: linear-gradient(90deg, #0b7c80, #40b4a7);
}

.schema-node b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 30px;
  border-radius: 999px;
  background: #eef4ff;
  color: #1f5eaa;
  font-size: 13px;
  font-weight: 950;
}

.schema-node h3,
.schema-node p {
  margin: 0;
}

.schema-node h3 {
  margin-top: 15px;
  color: #10233e;
  font-size: 18px;
  line-height: 1.22;
  font-weight: 900;
}

.schema-node p {
  margin-top: 9px;
  color: #475467;
  font-size: 12.5px;
  line-height: 1.45;
  font-weight: 700;
}

.schema-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8fa3bd;
  font-size: 28px;
  font-weight: 900;
}

.schema-branches {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 18px;
  margin-top: 22px;
}

.schema-branch {
  border-radius: 18px;
  padding: 20px;
  overflow: hidden;
}

.schema-branch::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 5px;
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.schema-branch.harness::before {
  background: linear-gradient(90deg, #10233e, #1f5eaa);
}

.schema-branch h3,
.schema-branch p {
  margin: 0;
}

.schema-branch h3 {
  color: #10233e;
  font-size: 19px;
  font-weight: 900;
}

.schema-branch p {
  margin-top: 13px;
  color: #475467;
  font-size: 13.5px;
  line-height: 1.55;
  font-weight: 700;
}

.branch-flow {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;
  margin-top: 18px;
}

.schema-branch.harness .branch-flow {
  grid-template-columns: repeat(5, 1fr);
}

.branch-flow span {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  border: 1px solid #d7dee9;
  border-radius: 14px;
  background: #f8fafc;
  color: #10233e;
  text-align: center;
  font-size: 12.5px;
  font-weight: 900;
}

.branch-flow span:not(:last-child)::after {
  content: "";
  position: absolute;
  right: -8px;
  top: 50%;
  width: 7px;
  height: 2px;
  background: #91a3ba;
}

.db-table-grid {
  display: grid;
  gap: 6px;
  margin-top: 4px;
}

.db-table-row {
  display: grid;
  grid-template-columns: 1.1fr 1fr 0.9fr 2.25fr 0.72fr;
  align-items: center;
  gap: 9px;
  min-height: 35px;
  border-radius: 12px;
  padding: 6px 10px;
  color: #344054;
  font-size: 12.5px;
  font-weight: 750;
}

.db-table-row.header {
  min-height: 38px;
  background: #10233e;
  color: #fff;
  box-shadow: none;
}

.db-table-row.header b {
  font-size: 12px;
  font-weight: 900;
}

.db-table-row .table-name {
  color: #1f5eaa;
  font-size: 14px;
  font-weight: 950;
}

.db-table-row strong {
  color: #10233e;
  font-size: 13.5px;
  font-weight: 950;
}

.db-table-row p {
  margin: 0;
  color: #475467;
  line-height: 1.35;
}

.db-table-row em {
  justify-self: start;
  min-width: 42px;
  border-radius: 999px;
  background: #e5f6f5;
  color: #08777b;
  padding: 5px 8px;
  font-style: normal;
  text-align: center;
  font-size: 11.5px;
  font-weight: 900;
}

.summary-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 24px;
}

.summary-card,
.data-highlight,
.decision-mini {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(190, 200, 214, 0.9);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.09);
}

.summary-card {
  min-height: 260px;
  padding: 30px 28px;
}

.summary-card::before,
.data-highlight::before,
.decision-mini::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 5px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa);
}

.summary-card:nth-child(2)::before,
.data-highlight:nth-child(2)::before {
  background: linear-gradient(90deg, #1f5eaa, #5c8ed8);
}

.summary-card:nth-child(3)::before,
.data-highlight:nth-child(3)::before {
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.summary-card h3,
.summary-card p,
.data-highlight h3,
.data-highlight p,
.decision-mini h3,
.decision-mini p {
  margin: 0;
}

.summary-card h3 {
  color: #10233e;
  font-size: 26px;
  line-height: 1.18;
  font-weight: 950;
}

.summary-card p {
  margin-top: 28px;
  color: #344054;
  font-size: 18px;
  line-height: 1.72;
  font-weight: 750;
}

.metric p {
  margin: 10px 0 0;
  color: #667085;
  font-size: 12.5px;
  line-height: 1.45;
  font-weight: 750;
}

.db-dashboard.focus {
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 12px;
}

.data-highlight-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 22px;
}

.data-highlight {
  min-height: 158px;
  padding: 24px 22px;
}

.data-highlight h3 {
  color: #10233e;
  font-size: 20px;
  font-weight: 950;
}

.data-highlight p {
  margin-top: 18px;
  color: #475467;
  font-size: 14px;
  line-height: 1.58;
  font-weight: 700;
}

.flow-lanes.compact {
  gap: 18px;
}

.timeline.compact {
  grid-template-columns: repeat(5, 1fr);
  margin-top: 44px;
}

.timeline.compact .timeline-item {
  min-height: 178px;
  padding: 20px 16px;
}

.decision-strip {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-top: 20px;
}

.decision-mini {
  min-height: 116px;
  padding: 18px 18px 16px;
}

.decision-mini h3 {
  color: #10233e;
  font-size: 16px;
  font-weight: 950;
}

.decision-mini p {
  margin-top: 10px;
  color: #667085;
  font-size: 12.5px;
  line-height: 1.48;
  font-weight: 700;
}

.layer-map {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 18px;
  margin-top: 18px;
}

.layer-card,
.signal-card,
.cause-node,
.demo-step,
.validation-card {
  position: relative;
  overflow: hidden;
  border: 1px solid rgba(190, 200, 214, 0.9);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.94);
  box-shadow: 0 18px 48px rgba(15, 23, 42, 0.09);
}

.layer-card {
  min-height: 250px;
  padding: 26px 24px;
}

.layer-card::before,
.signal-card::before,
.cause-node::before,
.demo-step::before,
.validation-card::before {
  content: "";
  position: absolute;
  inset: 0 0 auto;
  height: 5px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa);
}

.layer-card:nth-child(2)::before,
.demo-step:nth-child(2)::before,
.demo-step:nth-child(3)::before {
  background: linear-gradient(90deg, #1f5eaa, #5c8ed8);
}

.layer-card:nth-child(3)::before,
.demo-step:nth-child(4)::before,
.demo-step:nth-child(5)::before {
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.layer-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 34px;
  border-radius: 999px;
  background: #e5f6f5;
  color: #08777b;
  font-size: 15px;
  font-weight: 950;
}

.layer-card h3,
.layer-card p,
.layer-meta,
.signal-card span,
.signal-card strong,
.signal-card p,
.cause-node h3,
.cause-node p,
.demo-step h3,
.demo-step p,
.validation-card h3,
.validation-card p {
  margin: 0;
}

.layer-card h3 {
  margin-top: 20px;
  color: #10233e;
  font-size: 25px;
  line-height: 1.18;
  font-weight: 950;
}

.layer-meta {
  display: grid;
  gap: 8px;
  margin-top: 18px;
}

.layer-meta span,
.layer-meta strong {
  border-radius: 12px;
  padding: 9px 10px;
  font-size: 13px;
  line-height: 1.2;
  font-weight: 850;
}

.layer-meta span {
  background: #eef4ff;
  color: #1f5eaa;
}

.layer-meta strong {
  background: #f4f6f8;
  color: #10233e;
}

.layer-card p {
  margin-top: 18px;
  color: #475467;
  font-size: 14.5px;
  line-height: 1.58;
  font-weight: 700;
}

.layer-connector {
  display: grid;
  grid-template-columns: 1fr 42px 1fr 42px 1fr;
  align-items: center;
  gap: 12px;
  margin-top: 22px;
}

.layer-connector span,
.layer-connector b {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 50px;
  border-radius: 999px;
  font-weight: 950;
}

.layer-connector span {
  background: #10233e;
  color: #fff;
  font-size: 14px;
}

.layer-connector b {
  color: #8fa3bd;
  font-size: 26px;
}

.signal-board {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-top: 12px;
}

.signal-card {
  min-height: 156px;
  padding: 22px 20px;
}

.signal-card.ok::before {
  background: linear-gradient(90deg, #4b9155, #87bd77);
}

.signal-card.warn::before {
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.signal-card.stop::before {
  background: linear-gradient(90deg, #b94141, #db6b6b);
}

.signal-card span {
  display: block;
  color: #667085;
  font-size: 12.5px;
  font-weight: 900;
}

.signal-card strong {
  display: block;
  margin-top: 14px;
  color: #10233e;
  font-size: 23px;
  line-height: 1.14;
  font-weight: 950;
}

.signal-card p {
  margin-top: 14px;
  color: #475467;
  font-size: 13px;
  line-height: 1.45;
  font-weight: 700;
}

.cause-flow {
  display: grid;
  grid-template-columns: 1fr 42px 1fr 42px 1fr;
  align-items: stretch;
  gap: 12px;
  margin-top: 22px;
}

.cause-flow > b {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #8fa3bd;
  font-size: 30px;
  font-weight: 950;
}

.cause-node {
  min-height: 134px;
  padding: 24px 20px;
}

.cause-node.warn::before {
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.cause-node.stop::before {
  background: linear-gradient(90deg, #b94141, #db6b6b);
}

.cause-node h3 {
  color: #10233e;
  font-size: 20px;
  font-weight: 950;
}

.cause-node p {
  margin-top: 14px;
  color: #475467;
  font-size: 14px;
  line-height: 1.55;
  font-weight: 700;
}

.demo-flow {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
  margin-top: 14px;
}

.demo-step {
  min-height: 172px;
  padding: 22px 18px;
}

.demo-step b {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #e5f6f5;
  color: #08777b;
  font-size: 14px;
  font-weight: 950;
}

.demo-step h3 {
  margin-top: 18px;
  color: #10233e;
  font-size: 18px;
  font-weight: 950;
}

.demo-step p {
  margin-top: 12px;
  color: #475467;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 700;
}

.validation-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 14px;
  margin-top: 18px;
}

.validation-card {
  min-height: 126px;
  padding: 20px 18px;
}

.validation-card:nth-child(2)::before {
  background: linear-gradient(90deg, #1f5eaa, #5c8ed8);
}

.validation-card:nth-child(3)::before {
  background: linear-gradient(90deg, #4b9155, #87bd77);
}

.validation-card:nth-child(4)::before {
  background: linear-gradient(90deg, #b94141, #db6b6b);
}

.validation-card h3 {
  color: #10233e;
  font-size: 17px;
  font-weight: 950;
}

.validation-card p {
  margin-top: 10px;
  color: #667085;
  font-size: 12.5px;
  line-height: 1.48;
  font-weight: 700;
}

.executive-stack {
  margin-top: 20px;
  border-top: 3px solid #10233e;
  border-bottom: 3px solid #10233e;
  background: linear-gradient(90deg, rgba(255, 255, 255, 0.88), rgba(248, 250, 252, 0.72)), linear-gradient(90deg, rgba(11, 124, 128, 0.08), rgba(31, 94, 170, 0.04));
}

.executive-line {
  display: grid;
  grid-template-columns: 94px 1fr;
  gap: 26px;
  align-items: center;
  min-height: 138px;
  padding: 22px 8px;
  border-bottom: 1px solid rgba(16, 35, 62, 0.16);
}

.executive-line:last-child {
  border-bottom: 0;
}

.executive-line b {
  color: #0b7c80;
  font-size: 46px;
  line-height: 1;
  font-weight: 950;
  text-align: center;
}

.executive-line h3,
.executive-line p {
  margin: 0;
}

.executive-line h3 {
  color: #10233e;
  font-size: 28px;
  font-weight: 950;
}

.executive-line p {
  margin-top: 10px;
  color: #344054;
  font-size: 17px;
  line-height: 1.62;
  font-weight: 750;
}

.service-matrix {
  margin-top: 18px;
  border-top: 3px solid #10233e;
  border-bottom: 3px solid #10233e;
}

.matrix-head,
.matrix-row {
  display: grid;
  grid-template-columns: 100px 1.05fr 1.2fr 1.7fr 2fr;
  align-items: center;
  gap: 16px;
}

.matrix-head {
  min-height: 44px;
  color: #667085;
  font-size: 12px;
  font-weight: 950;
  border-bottom: 1px solid rgba(16, 35, 62, 0.18);
}

.matrix-row {
  min-height: 116px;
  border-bottom: 1px solid rgba(16, 35, 62, 0.14);
}

.matrix-row:last-child {
  border-bottom: 0;
}

.matrix-row b {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 76px;
  height: 44px;
  border-radius: 999px;
  background: #10233e;
  color: #fff;
  font-size: 16px;
  font-weight: 950;
}

.matrix-row h3,
.matrix-row span,
.matrix-row strong,
.matrix-row p {
  margin: 0;
}

.matrix-row h3 {
  color: #10233e;
  font-size: 22px;
  font-weight: 950;
}

.matrix-row span,
.matrix-row strong {
  color: #1f5eaa;
  font-size: 14px;
  line-height: 1.35;
  font-weight: 850;
}

.matrix-row strong {
  color: #0b7c80;
}

.matrix-row p {
  color: #475467;
  font-size: 14px;
  line-height: 1.48;
  font-weight: 700;
}

.process-ribbon {
  display: grid;
  grid-template-columns: 1fr 58px 1fr 58px 1fr;
  align-items: center;
  gap: 12px;
  margin-top: 22px;
}

.process-ribbon span {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 48px;
  border-radius: 999px;
  background: #10233e;
  color: #fff;
  font-size: 14px;
  font-weight: 950;
}

.process-ribbon i {
  height: 3px;
  border-radius: 999px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa);
}

.data-scale {
  display: grid;
  gap: 16px;
  margin-top: 14px;
}

.scale-row {
  display: grid;
  grid-template-columns: 72px 1fr 120px 210px;
  align-items: center;
  gap: 18px;
  min-height: 58px;
}

.scale-row span,
.scale-row strong,
.scale-row p {
  margin: 0;
}

.scale-row > span {
  color: #10233e;
  font-size: 18px;
  font-weight: 950;
}

.scale-track {
  height: 22px;
  border-radius: 999px;
  background: #e4eaf2;
  overflow: hidden;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.1);
}

.scale-track i {
  display: block;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa);
}

.scale-row.s1 .scale-track i {
  width: 100%;
}

.scale-row.s2 .scale-track i {
  width: 91%;
}

.scale-row.s3 .scale-track i {
  width: 32%;
  background: linear-gradient(90deg, #4b9155, #87bd77);
}

.scale-row.s4 .scale-track i {
  width: 18%;
  background: linear-gradient(90deg, #da8b1f, #edb457);
}

.scale-row strong {
  color: #10233e;
  font-size: 21px;
  font-weight: 950;
}

.scale-row p {
  color: #667085;
  font-size: 13px;
  line-height: 1.38;
  font-weight: 750;
}

.storage-lines {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  margin-top: 28px;
  border-top: 2px solid rgba(16, 35, 62, 0.2);
  border-bottom: 2px solid rgba(16, 35, 62, 0.2);
}

.storage-line {
  min-height: 138px;
  padding: 22px 18px;
  border-right: 1px solid rgba(16, 35, 62, 0.14);
}

.storage-line:last-child {
  border-right: 0;
}

.storage-line h3,
.storage-line p {
  margin: 0;
}

.storage-line h3 {
  color: #10233e;
  font-size: 19px;
  font-weight: 950;
}

.storage-line p {
  margin-top: 16px;
  color: #475467;
  font-size: 13.5px;
  line-height: 1.55;
  font-weight: 700;
}

.clinic-journey {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 18px;
  margin-top: 38px;
  padding-top: 34px;
}

.clinic-journey::before {
  content: "";
  position: absolute;
  top: 52px;
  left: 7%;
  right: 7%;
  height: 5px;
  border-radius: 999px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa 34%, #da8b1f 68%, #4b9155);
}

.clinic-step {
  position: relative;
  min-height: 184px;
  padding-top: 76px;
}

.clinic-step b {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  border: 6px solid #f8fafc;
  border-radius: 50%;
  background: #10233e;
  color: #fff;
  font-size: 17px;
  font-weight: 950;
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.18);
}

.clinic-step h3,
.clinic-step p,
.clinic-track h3,
.clinic-track p {
  margin: 0;
}

.clinic-step h3 {
  color: #10233e;
  font-size: 19px;
  line-height: 1.22;
  font-weight: 950;
}

.clinic-step p {
  margin-top: 12px;
  color: #475467;
  font-size: 13.5px;
  line-height: 1.48;
  font-weight: 730;
}

.clinic-track-lines {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 34px;
  margin-top: 22px;
  border-top: 2px solid rgba(16, 35, 62, 0.22);
}

.clinic-track {
  display: grid;
  grid-template-columns: 166px 1fr;
  align-items: center;
  min-height: 68px;
  border-bottom: 1px solid rgba(16, 35, 62, 0.16);
}

.clinic-track h3 {
  color: #0b7c80;
  font-size: 16px;
  line-height: 1.25;
  font-weight: 950;
}

.clinic-track p {
  color: #344054;
  font-size: 13.5px;
  line-height: 1.42;
  font-weight: 750;
}

.demo-rail {
  position: relative;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
  margin-top: 54px;
}

.demo-rail::before {
  content: "";
  position: absolute;
  left: 5%;
  right: 5%;
  top: 29px;
  height: 4px;
  border-radius: 999px;
  background: linear-gradient(90deg, #0b7c80, #1f5eaa, #da8b1f, #4b9155);
}

.rail-step {
  position: relative;
  min-height: 160px;
  padding-top: 74px;
}

.rail-step b {
  position: absolute;
  left: 0;
  top: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 62px;
  height: 62px;
  border-radius: 50%;
  background: #10233e;
  color: #fff;
  font-size: 18px;
  font-weight: 950;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.16);
}

.rail-step h3,
.rail-step p {
  margin: 0;
}

.rail-step h3 {
  color: #10233e;
  font-size: 19px;
  font-weight: 950;
}

.rail-step p {
  margin-top: 10px;
  color: #475467;
  font-size: 13px;
  line-height: 1.5;
  font-weight: 700;
}

.validation-lines {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 0 26px;
  margin-top: 22px;
  border-top: 2px solid rgba(16, 35, 62, 0.18);
}

.validation-line {
  display: grid;
  grid-template-columns: 142px 1fr;
  gap: 16px;
  align-items: center;
  min-height: 58px;
  border-bottom: 1px solid rgba(16, 35, 62, 0.14);
}

.validation-line h3,
.validation-line p {
  margin: 0;
}

.validation-line h3 {
  color: #10233e;
  font-size: 15px;
  font-weight: 950;
}

.validation-line p {
  color: #667085;
  font-size: 12.5px;
  line-height: 1.35;
  font-weight: 700;
}

.task-grid {
  grid-template-columns: 1fr;
  gap: 0;
  border-top: 3px solid #10233e;
  border-bottom: 3px solid #10233e;
}

.task-grid .task-card {
  display: grid;
  grid-template-columns: 66px 220px 1fr;
  gap: 18px;
  align-items: center;
  min-height: 76px;
  border: 0;
  border-bottom: 1px solid rgba(16, 35, 62, 0.14);
  border-radius: 0;
  background: transparent;
  box-shadow: none;
  padding: 12px 4px;
}

.task-grid .task-card:last-child {
  border-bottom: 0;
}

.task-grid .task-card::before {
  display: none;
}

.task-grid .task-card span {
  min-width: 48px;
  height: 32px;
}

.task-grid .task-card h3,
.task-grid .task-card p {
  margin: 0;
}

.task-grid .task-card h3 {
  font-size: 18px;
}

.task-grid .task-card p {
  font-size: 13.5px;
  line-height: 1.42;
}

@media (max-width: 980px) {
  .ppt-toolbar {
    height: auto;
    min-height: 68px;
    flex-wrap: wrap;
    padding: 12px 16px;
  }
  .ppt-brand {
    min-width: 190px;
  }
  .ppt-shell {
    --slide-width: calc(100vw - 36px);
    height: calc(100vh - 92px);
  }
  .ppt-slide {
    flex-basis: var(--slide-width);
    min-height: 0;
    padding: 34px 32px;
  }
}
@page {
  size: 13.333in 7.5in;
  margin: 0;
}
@media print {
  :host,
  .ppt-page {
    background: #fff !important;
  }
  .ppt-toolbar {
    display: none !important;
  }
  .ppt-shell {
    display: block !important;
    height: auto !important;
    overflow: visible !important;
    padding: 0 !important;
    background: #fff !important;
  }
  .ppt-slide {
    width: 13.333in !important;
    height: 7.5in !important;
    min-height: 0 !important;
    max-height: none !important;
    margin: 0 !important;
    border: 0 !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    page-break-after: always;
    break-after: page;
  }
  .ppt-slide:last-child {
    page-break-after: auto;
    break-after: auto;
  }
}`],
})
export class PagePptComponent {
    public activeIndex: number = 0;
    public slideCount: number = 13;
    private ticking: boolean = false;

    public summaryPoints: any[] = [
        { title: '핵심 변화', desc: '2026 한의 저작도구는 파일 관리 도구가 아니라 문서 원장, 검색, QA 작성, 검수, 평가를 연결하는 운영 체계로 전환 중' },
        { title: '현재 상태', desc: '자료 원장과 주요 화면은 구축되어 있으나 원장 정합성, QA 생성 품질, 평가 운영은 보정 필요' },
        { title: '추진 방향', desc: '원장 안정화 후 LLM QA 생성, 진료지원 시나리오, 평가/골든셋, RAG/MCP 고도화 순서로 진행하는 것이 적절' }
    ];

    public businessCards: any[] = [
        { label: '목표', value: 'RAG 저작도구·진료지원 Agent 고도화', caption: '자료 준비부터 진료지원과 평가까지 이어지는 운영 체계' },
        { label: '기간', value: '2026.12.11까지', caption: '인수 산출물과 시험운영 결과 포함' },
        { label: '예산', value: '99,000,000원', caption: 'RAG, Agent, 학습데이터, 평가도구 구축 범위' },
        { label: '성과', value: 'QA·검수·평가·진료지원 운영화', caption: '근거 추적 가능한 학습데이터와 진료지원 시나리오 확보' }
    ];

    public serviceLayers: any[] = [
        { stage: '1단계', title: '운영 점검', pages: 'dashboard · harness', data: '실행 이력 · 품질 기준 · 검증 추적', desc: '서비스 실행 결과와 실패 원인을 확인하고 인수 기준을 점검' },
        { stage: '2단계', title: '자료 준비', pages: 'literature', data: '문서 · 파일 · 페이지 · 청크 · 벡터', desc: '원본 자료를 검색과 QA 생성에 쓸 수 있는 근거 단위로 정리' },
        { stage: '3단계', title: 'QA·검수·평가', pages: 'qa · review · eval', data: 'QA 데이터셋 · 문항 · 검수 · 평가결과', desc: '생성된 QA를 검수하고 평가 결과를 골든셋 전환 기준으로 활용' }
    ];

    public dbMetrics: any[] = [
        { label: 'vec', value: '약 149만', caption: 'Milvus 검색 색인 원장' },
        { label: 'chunk', value: '약 136만', caption: 'QA 근거 청크' },
        { label: 'page', value: '약 47만', caption: 'OCR/텍스트 페이지' },
        { label: 'file', value: '약 26만', caption: '원본·파생 파일 메타' }
    ];

    public dataHighlights: any[] = [
        { title: 'MySQL', desc: '문서, 파일, 페이지, 청크, 벡터 상태를 관리하는 기준 원장' },
        { title: 'Milvus', desc: '유사 청크 후보를 찾는 검색 인덱스. 최종 판단은 MySQL 원장으로 재조회' },
        { title: 'File Storage', desc: '원본 파일과 OCR/embedding/status JSON 보관. MySQL path/checksum으로 추적' },
        { title: '하네스', desc: '업로드·벡터 처리 엔진이 아니라 원장 상태를 사후 점검하는 검증 구조' }
    ];

    public clinicTracks: any[] = [
        { title: 'RAG/MCP 고도화', desc: '질환별 처방 추천 질의 확장, 추천 근거 시각화 UI/UX' },
        { title: '진료지원 Agent', desc: '문진, 진단, 변증, 처방, 경과관찰 시나리오 기반 Agent Tool' },
        { title: '진료 데이터 수집', desc: '정량화 진료 데이터, ROM·설진 측정, EMR 연동 API 검토' },
        { title: '평가·실증', desc: '평가 전문 Agent, 임상 실증 파일럿, 시험운영 결과 리포트' }
    ];

    public clinicScenario: any[] = [
        { title: '진료 맥락 입력', desc: '증상, 질환, 변증, 처방 후보 조건' },
        { title: 'RAG/MCP 검색', desc: '문헌 근거, 지식그래프, 처방·본초 연결' },
        { title: 'Agent 판단', desc: '질의 확장, 후보 비교, 추천 근거 구성' },
        { title: '근거 시각화', desc: '추천 이유, 출처, 주의사항, 대안 제시' },
        { title: '평가·피드백', desc: '전문가 검토, 평가 Agent, 학습데이터 환류' }
    ];

    public flowHarnessChecks: any[] = [
        { label: 'run', desc: '실행 단위' },
        { label: 'step', desc: '단계 상태' },
        { label: 'artifact', desc: '산출물' },
        { label: 'gate', desc: '품질 판정' },
        { label: 'trace', desc: '환류 경로' },
        { label: 'audit', desc: '검수 기록' }
    ];

    public progressColumns: any[] = [
        {
            state: '구축됨',
            title: '업무 화면과 원장 기반',
            items: [
                '자료 준비, QA 작성, 검수, 평가, 운영 점검 화면 골격',
                '문서·파일·페이지·청크·벡터 기준 원장 구조',
                'MySQL 원장과 Milvus 검색 역할 분리',
                'dashboard/harness 기반 운영 상태 확인'
            ]
        },
        {
            state: '보정 중',
            title: '초기 운영과 품질 검증',
            items: [
                '신규 업로드 후 원장 집계와 QA ready 기준 동기화',
                'QA 후보 생성 품질과 응답성 보정',
                '검수 큐 운영 데이터 축적',
                '평가 run과 골든셋 전환 기준선 확보'
            ]
        },
        {
            state: '후속 구축',
            title: 'RFP 신규·확장 범위',
            items: [
                'LLM 기반 QA/Instruction 생성과 DPO 데이터',
                '평가 전문 Agent와 자동 리포트',
                '지식그래프, RAG/MCP, 진료지원 Agent',
                '미세조정, EMR 연동, 임상 실증'
            ]
        }
    ];

    public progressEvidence: any[] = [
        { label: '구현 기반', value: '주요 업무 화면과 역할별 API 존재' },
        { label: '데이터 기반', value: '대형 page·chunk·vec 원장 존재' },
        { label: '초기 운영', value: 'QA 후보와 검수 큐 구조 존재' },
        { label: '미완료', value: '평가 운영 데이터와 진료지원 Agent 후속 구축' }
    ];

    public tasks: any[] = [
        { level: 'P0', title: '원장 정합성', desc: '업로드 후 문서·파일·페이지 상태와 QA ready 기준 동기화' },
        { level: 'P0', title: 'QA 생성 품질', desc: '근거 추출형 MVP를 LLM 기반 QA 생성으로 전환' },
        { level: 'P0', title: '평가 샘플', desc: '평가 run과 리포트 최소 1회 생성해 기준선 확보' },
        { level: 'P1', title: 'RAG/MCP·진료지원', desc: '질환별 처방 추천, 근거 시각화, Agent Tool 연결' },
        { level: 'P1', title: 'DPO/미세조정', desc: '검수 결과 기반 선호쌍과 학습 파이프라인 구축' },
        { level: 'P2', title: '운영 인수', desc: '성능, 보안, 매뉴얼, 교육, 기술이전 산출물 정리' }
    ];

    public roadmap: any[] = [
        { month: '6월', title: '원장 안정화', desc: '집계, QA ready, OCR 실패 처리' },
        { month: '7월', title: 'QA 생성 전환', desc: 'LLM 생성, citation, 검수 샘플' },
        { month: '8월', title: '평가 운영화', desc: '평가 run, 리포트, 골든셋' },
        { month: '9~10월', title: '진료지원 Agent', desc: 'RAG/MCP, 처방 추천, 근거 시각화' },
        { month: '11~12월', title: '시험운영·인수', desc: '임상 실증 파일럿, 교육, 기술이전' }
    ];

    public decisions: any[] = [
        { title: 'QA 생성 기준', desc: '모델, 프롬프트, citation 필수 여부' },
        { title: '평가 기준선', desc: '초기 골든셋 규모와 검수 방식' },
        { title: '진료지원 범위', desc: '질환, 처방, 본초, 경혈 중 1차 시나리오 범위' },
        { title: '시범운영 범위', desc: '참여자, 기간, 피드백 반영 절차' }
    ];

    public demoSteps: any[] = [
        { title: '자료 업로드', desc: '원본 저장과 파일 원장 생성' },
        { title: '근거화', desc: 'OCR/Text, chunk, embedding, Milvus 색인' },
        { title: 'QA·Instruction', desc: '근거 기반 후보와 진료 단계별 instruction 생성' },
        { title: '진료지원 질의', desc: '질환별 처방 추천과 추천 근거 시각화' },
        { title: '평가·실증', desc: 'eval run, 전문가 검토, 시험운영 리포트' }
    ];

    public validationChecks: any[] = [
        { title: '원장 정합성', desc: '문서·파일·페이지·청크 상태와 QA ready 기준 일치' },
        { title: '생성 품질', desc: 'extractive MVP에서 LLM QA 생성으로 전환' },
        { title: '진료지원 적합성', desc: '추천 근거, 안전성, 한의사 진료환경 적합성 확인' },
        { title: '운영 보안', desc: '개인정보, EMR 연동, 역할 정책, 접근 로그 점검' }
    ];

    public async ngOnInit() {
        setTimeout(() => this.syncCount(), 0);
    }

    public syncCount() {
        this.slideCount = this.slides().length || this.slideCount;
    }

    public slides(): HTMLElement[] {
        return Array.from(document.querySelectorAll('.ppt-slide')) as HTMLElement[];
    }

    public deck(): HTMLElement | null {
        return document.getElementById('pptDeck');
    }

    public go(delta: number) {
        this.scrollTo(this.activeIndex + delta);
    }

    public scrollTo(index: number) {
        const deck = this.deck();
        const slides = this.slides();
        if (!deck || slides.length === 0) return;
        const next = Math.max(0, Math.min(index, slides.length - 1));
        const target = slides[next];
        const centeredLeft = target.offsetLeft - deck.offsetLeft - ((deck.clientWidth - target.clientWidth) / 2);
        deck.scrollTo({ left: Math.max(0, centeredLeft), behavior: 'smooth' });
        this.activeIndex = next;
    }

    public onScroll() {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
            const deck = this.deck();
            const slides = this.slides();
            if (!deck || slides.length === 0) {
                this.ticking = false;
                return;
            }
            const center = deck.scrollLeft + deck.clientWidth / 2;
            let best = 0;
            let bestDistance = Number.POSITIVE_INFINITY;
            slides.forEach((slide, index) => {
                const slideCenter = slide.offsetLeft + slide.clientWidth / 2;
                const distance = Math.abs(slideCenter - center);
                if (distance < bestDistance) {
                    bestDistance = distance;
                    best = index;
                }
            });
            this.activeIndex = best;
            this.ticking = false;
        });
    }

    public exportPdf() {
        const previous = document.title;
        document.title = 'kiom-authoring-2026-meeting-deck';
        document.body.classList.add('ppt-printing');
        setTimeout(() => {
            window.print();
            setTimeout(() => {
                document.body.classList.remove('ppt-printing');
                document.title = previous;
            }, 500);
        }, 80);
    }

    @HostListener('window:keydown', ['$event'])
    public onKeydown(event: KeyboardEvent) {
        if (event.key === 'ArrowRight' || event.key === 'PageDown') this.go(1);
        if (event.key === 'ArrowLeft' || event.key === 'PageUp') this.go(-1);
    }
}

export default PagePptComponent;